import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { institutionBarStyles } from '../../../../global/constants/theme/styles/components/institution-bar';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { NavigationContext } from '../../../../global/models/app-context-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { AnnualEnrollmentRoutes } from '../../../annual-enrollment/constants/annual-enrollment-routes';
import { ArcRoutes } from '../../constants/routes';
import { SearchProps } from '../../models/arc-epi-props';
import { BillingAccount } from './billing-accounts-models';

export const BillingAccountInfoSection = () => {
    const classes = institutionBarStyles();
    const billingAccount = useSelector<TcsmStates, BillingAccount>(state => state.billingAccountsState.currentBillingAccount);
    const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
    const billingAccountPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}`);
    const matchedPaths = [
        useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.PersonalInformation}`),
        AnnualEnrollmentRoutes.AnnualEnrollment,
        ArcRoutes.Coverage,
        useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}`)];

    const userNavigationContext = useSelector<TcsmStates, NavigationContext>(state => state.appContext.userNavigationContext);

    const currentPath = window.location?.pathname;
    if ((userNavigationContext !== NavigationContext.BillingAccount) || !billingAccount || !matchedPaths.some(a => currentPath?.toLowerCase()?.includes(a?.toLowerCase()))) {
        return null;
    }

    return (
        <div className={classes.institutionBarContainer}>
            <p className='input-label institution-bar-number'>{searchSettings?.billingAccountInfoTitle}: {billingAccount?.account_number}</p>
            <div className='institution-bar-inner'>
                <p className='institution-bar-name'>{billingAccount?.account_name}</p>
                <Link to={billingAccountPath}>{searchSettings.pickBillingAccounts}</Link>
            </div>
        </div>
    );
};